// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2O2oU","range":"MonthRangeSwitch_range__266OS","disabled":"MonthRangeSwitch_disabled__bC40Q"};